















































import IGood from '@/store/models/IGood';
import { Vue, Component, Watch } from 'vue-property-decorator';
import GoodApi from '../store/api/GoodApi';
import GoodSelector from '@/components/selectors/Good/GoodSelector.vue';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import StockApi from '../store/api/StockApi';
import ExciseTariffManager from '@/components/Excise/ExciseTariffManager.vue';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
@Component({
    components: {
        GoodSelector,
        Snackbar,
        ExciseTariffManager
    }
})
export default class Goods extends Vue {
    GoodList : IGood[] = [];
    goodApi : GoodApi;
    stockApi : StockApi;
    selectedGood : IGood | null = null;
    idGood : string = "";
    permissions : IRolePermission[] = [];
    companyId : string = "";
    overlay : boolean = false;
    dialogExciseTariffManager: boolean = false;
    settingsCompanyApi : SettingsCompanyApi;
    enableExciseModule: boolean = false;
    constructor() {
        super();
        this.goodApi = new GoodApi();
        this.stockApi = new StockApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Goods");
    }

    created() {
        this.getPermissions();
        this.getGoods();
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Goods"));
        let settingsCompany = SettingsCompany.Settings.EnableAGPExciseModule;
        let setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            this.enableExciseModule = true;
        }
    }

    openExciseTariffManager() {
        this.dialogExciseTariffManager = true;
    }
    
    async getGoods() {
        this.GoodList = await this.goodApi.GetGoods();
    }

    deleteGood (item: IGood) {
        confirm('Are you sure you want to delete this good?') && this.deleteGoodItem(item);
    }

    async deleteGoodItem(good: IGood) {
        this.overlay = true;
        let canDelete = await this.stockApi.CanDeleteProduct(good.id);
        if (canDelete) {
            let result: boolean = await this.goodApi.DeleteGood(good.id);
            if (result) {
                const index = this.GoodList.indexOf(good);
                this.GoodList.splice(index, 1);
                this.showMessageInfo(`The good ${good.name} has been successfully deleted`);
            } else {
                const errors: string = this.goodApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        } else {
            this.showMessageWarning("The selected product is in stock and cannot be deleted");
        }
        this.overlay = false;
    }

    async saveGood (good: IGood) {
        this.overlay = true;
        const id = await this.goodApi.SaveGood(good);
        if (id) {
            good.id = id;
            this.GoodList = [good].concat(this.GoodList);
            this.selectedGood = good;
            this.showMessageInfo(`The good ${good.name} has been successfully saved`);
        } else {
            const errors: string = this.goodApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editGood (editedGood: IGood) {
        this.overlay = true;
        let result : boolean = await this.goodApi.UpdateGood(editedGood);
        if (result) {
            this.showMessageInfo(`The good ${editedGood.name} has been successfully edited`);
        } else {
            const errors: string = this.goodApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    resetGood() {
        this.selectedGood = null;
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
